function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//@ts-nocheck
import { BlockComponent } from "../../../framework/src/BlockComponent";
import { runEngine } from "../../../framework/src/RunEngine";
import { Message } from "../../../framework/src/Message";
import MessageEnum, { getName } from "../../../framework/src/Messages/MessageEnum";

// Customizable Area Start
import * as Yup from "yup";
// Customizable Area End

export const configJSON = require("./config");
// Customizable Area Start
const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
const passwordInvisibleImage = require("../assets/ic_password_invisible.png");
const passwordVisibleImage = require("../assets/ic_password_visible.png");
const emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/;
const email_mobile_Regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
const mobile_regex = /^(?:\d{12}|\w+@\w+\.\w{2,3})$/;
const number_test = /^\d+$/;
// Customizable Area End

export default class ForgotPasswordController extends BlockComponent {
  // Customizable Area End

  constructor(props) {
    super(props);
    // Customizable Area Start
    //Properties from config
    _defineProperty(this, "labelTextIsAccountRecovery", configJSON.labelTextIsAccountRecovery);
    _defineProperty(this, "secondLabelText", configJSON.secondLabelText);
    _defineProperty(this, "thirdLabelText", configJSON.thirdLabelText);
    _defineProperty(this, "forthLabelText", configJSON.forthLabelText);
    _defineProperty(this, "fifthLabelText", configJSON.fifthLabelText);
    _defineProperty(this, "sixthLabelText", configJSON.sixthLabelText);
    _defineProperty(this, "firstInputAutoCompleteType", configJSON.firstInputAutoCompleteType);
    _defineProperty(this, "firstInputKeyboardStyle", configJSON.firstInputKeyboardStyle);
    _defineProperty(this, "firstInputPlaceholder", configJSON.firstInputPlaceholder);
    _defineProperty(this, "firstInputErrorColor", configJSON.firstInputErrorColor);
    _defineProperty(this, "buttonTextIsNext", configJSON.buttonTextIsNext);
    _defineProperty(this, "buttonColorForNextButton", configJSON.buttonColorForNextButton);
    _defineProperty(this, "secondInputAutoCompleteType", configJSON.secondInputAutoCompleteType);
    _defineProperty(this, "secondInputKeyboardType", configJSON.secondInputKeyboardType);
    _defineProperty(this, "secondInputPlaceholder", configJSON.secondInputPlaceholder);
    _defineProperty(this, "secondInputErrorColor", configJSON.secondInputErrorColor);
    _defineProperty(this, "thirdInputPlaceholder", configJSON.thirdInputPlaceholder);
    _defineProperty(this, "thirdInputErrorColor", configJSON.thirdInputErrorColor);
    _defineProperty(this, "buttonTitleIsSMSPhoneAccount", configJSON.buttonTitleIsSMSPhoneAccount);
    _defineProperty(this, "buttonTitleIsEmailAccount", configJSON.buttonTitleIsEmailAccount);
    _defineProperty(this, "labelTextIsPleaseEnterYourNewPassword", configJSON.labelTextIsPleaseEnterYourNewPassword);
    _defineProperty(this, "labelTextIsYourPasswordHasBeenSuccessfullyChanged", configJSON.labelTextIsYourPasswordHasBeenSuccessfullyChanged);
    _defineProperty(this, "placeholderIsPassword", configJSON.placeholderIsPassword);
    _defineProperty(this, "passwordVisibleImage", passwordVisibleImage);
    _defineProperty(this, "passwordInvisibleImage", passwordInvisibleImage);
    _defineProperty(this, "placeholderIsReTypePassword", configJSON.placeholderIsReTypePassword);
    _defineProperty(this, "buttonTitleIsOk", configJSON.buttonTitleIsOk);
    _defineProperty(this, "buttonColorForOkButton", configJSON.buttonColorForOkButton);
    _defineProperty(this, "countryCodeSelectorPlaceholder", configJSON.countryCodeSelectorPlaceholder);
    // Customizable Area Start
    _defineProperty(this, "validationRulesRequest", () => {
      const header = {
        "Content-Type": configJSON.forgotPasswordAPiContentType
      };
      const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
      this.validationAPICallId = requestMessage.messageId;
      requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), configJSON.profileValidationSettingsAPiEndPoint);
      requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
      requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), configJSON.httpGetMethod);
      runEngine.sendMessage(requestMessage.id, requestMessage);
    });
    _defineProperty(this, "handleEmailChange", event => {
      // console.log(email_mobile_Regex.test(event.target.value));
      if (number_test.test(event.target.value)) {
        if (!mobile_regex.test(event.target.value)) {
          this.setState({
            registeredEmail: event.target.value,
            isRegisteredEmailValid: false,
            registeredEmailErrorMessage: "Please enter a valid email / mobile number."
          });
        } else {
          this.setState({
            registeredEmail: event.target.value,
            isRegisteredEmailValid: true,
            registeredEmailErrorMessage: ""
          });
        }
      } else {
        if (!email_mobile_Regex.test(event.target.value)) {
          this.setState({
            registeredEmail: event.target.value,
            isRegisteredEmailValid: false,
            registeredEmailErrorMessage: "Please enter a valid email / mobile number."
          });
        } else {
          this.setState({
            registeredEmail: event.target.value,
            isRegisteredEmailValid: true,
            registeredEmailErrorMessage: ""
          });
        }
      }
    });
    _defineProperty(this, "handleSendOtpClick", () => {
      if (this.state.registeredEmail.length != 0 && this.state.isRegisteredEmailValid) {
        this.makeCallForOtp();
      } else {
        if (this.state.registeredEmail.length == 0) {
          this.setState({
            isRegisteredEmailValid: false,
            registeredEmailErrorMessage: "Field cannot be blank."
          });
        }
      }
    });
    _defineProperty(this, "makeCallForOtp", () => {
      const header = {
        "Content-Type": configJSON.forgotPasswordAPiContentType
      };
      const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
      //GO TO REQUEST STATE
      this.sendOtpEmailApiCallId = requestMessage.messageId;
      requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), configJSON.forgotPasswordEndPoint);
      requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
      const keyName = email_mobile_Regex.test(this.state.registeredEmail) ? "email" : "full_phone_number";
      const httpBody = {
        data: {
          [keyName]: this.state.registeredEmail
        }
      };
      requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), configJSON.httpPostMethod);
      requestMessage.addData(getName(MessageEnum.RestAPIRequestBodyMessage), JSON.stringify(httpBody));
      runEngine.sendMessage(requestMessage.id, requestMessage);
      return true;
    });
    _defineProperty(this, "handleOtpChange", otp => {
      this.setState({
        otp,
        isOtpValid: true,
        otpErrorMessage: ""
      });
    });
    _defineProperty(this, "handleOtpSubmit", () => {
      if (this.state.otp !== "") {
        this.validateOtp();
      } else {
        this.setState({
          isOtpValid: false,
          otpErrorMessage: "Please enter OTP."
        });
      }
    });
    _defineProperty(this, "validateOtp", () => {
      const header = {
        "Content-Type": configJSON.forgotPasswordAPiContentType
      };
      const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
      //GO TO REQUEST STATE
      this.validateOtpApiCallId = requestMessage.messageId;
      requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), configJSON.validateOtpEndPoint);
      requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
      const httpBody = {
        data: {
          token: localStorage.getItem("token"),
          otp_code: this.state.otp
        }
      };
      requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), configJSON.httpPostMethod);
      requestMessage.addData(getName(MessageEnum.RestAPIRequestBodyMessage), JSON.stringify(httpBody));
      runEngine.sendMessage(requestMessage.id, requestMessage);
      return true;
    });
    _defineProperty(this, "handleNewPasswordChange", event => {
      if (event.target.value !== "") {
        this.setState({
          newPassword: event.target.value,
          isNewPasswordValid: true,
          newPasswordErrorMessage: ""
        });
      } else {
        this.setState({
          newPassword: "",
          isNewPasswordValid: false,
          newPasswordErrorMessage: "Field Cannot be blank."
        });
      }
    });
    _defineProperty(this, "handleConfirmPasswordChange", event => {
      if (event.target.value !== "") {
        if (this.state.newPassword == event.target.value) {
          this.setState({
            confirmPassword: event.target.value,
            isConfirmPasswordValid: true,
            confirmPasswordErrorMessage: ""
          });
        } else {
          this.setState({
            confirmPassword: event.target.value,
            isConfirmPasswordValid: false,
            confirmPasswordErrorMessage: "Password Does not Match"
          });
        }
      } else {
        this.setState({
          confirmPassword: "",
          isConfirmPasswordValid: false,
          confirmPasswordErrorMessage: "Field cannot be blank."
        });
      }
    });
    _defineProperty(this, "handleResetPasswordClick", () => {
      if (this.state.newPassword !== "" && this.state.confirmPassword !== "" && this.state.isNewPasswordValid && this.state.isConfirmPasswordValid) {
        this.resetPassword();
      } else {
        if (this.state.newPassword !== this.state.confirmPassword) {
          this.setState({
            isConfirmPasswordValid: false,
            confirmPasswordErrorMessage: "Password does not match"
          });
        }
        if (this.state.newPassword == "") {
          this.setState({
            isNewPasswordValid: false,
            newPasswordErrorMessage: "Field cannot be blank."
          });
        }
        if (this.state.confirmPassword == "") {
          this.setState({
            isConfirmPasswordValid: false,
            confirmPasswordErrorMessage: "Field cannot be blank."
          });
        }
      }
    });
    _defineProperty(this, "resetPassword", () => {
      const header = {
        "Content-Type": configJSON.forgotPasswordAPiContentType
      };
      const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
      //GO TO REQUEST STATE
      this.resetPasswordApiCallId = requestMessage.messageId;
      requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), configJSON.newPasswordEndPoint);
      requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
      const httpBody = {
        data: {
          token: localStorage.getItem("token"),
          new_password: this.state.newPassword
        }
      };
      requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), configJSON.httpPostMethod);
      requestMessage.addData(getName(MessageEnum.RestAPIRequestBodyMessage), JSON.stringify(httpBody));
      runEngine.sendMessage(requestMessage.id, requestMessage);
      return true;
    });
    this.subScribedMessages = [
    // Customizable Area Start
    getName(MessageEnum.RestAPIResponceMessage), getName(MessageEnum.NavigationPayLoadMessage), getName(MessageEnum.CountryCodeMessage)
    // Customizable Area End
    ];
    this.receive = this.receive.bind(this);
    runEngine.attachBuildingBlock(this, this.subScribedMessages);

    // Customizable Area Start
    //email schema
    let emailSchema = {
      email: Yup.string().email(configJSON.pleaseEnterAValidEmail).required(configJSON.emailIsRequired).test(emailRegex)
    };

    //phone schema
    let phoneSchema = {
      // countryCode: Yup.number()
      // .required("Country code is required"),

      phone: Yup.string().matches(phoneRegExp, configJSON.phoneNumberIsNotValid).required(configJSON.phoneNumberIsRequired)
    };

    //otpSchema
    let otpSchema = {
      otpCode: Yup.number().min(4).required(configJSON.otpCodeIsRequired)
    };

    //passwordSchema
    let passwordSchema = {
      password: Yup.string().required(configJSON.pleaseEnterAPassword).min(2, configJSON.passwordMustBeAtLeast2Characters),
      confirmPassword: Yup.string().required(configJSON.pleaseConfirmYourPassword).when("password", {
        is: val => val && val.length > 0 ? true : false,
        then: Yup.string().oneOf([Yup.ref("password")], configJSON.passwordsMustMatch)
      })
    };
    this.state = {
      accountType: "sms",
      accountStatus: "ChooseAccountType",
      emailValue: "",
      phoneValue: "",
      countryCodeSelected: "",
      passwordRules: "",
      emailSchema: emailSchema,
      phoneSchema: phoneSchema,
      otpSchema: otpSchema,
      passwordSchema: passwordSchema,
      token: "",
      enablePasswordField: true,
      btnConfirmPasswordShowHide: true,
      registeredEmail: "",
      otp: "",
      isRegisteredEmailValid: false,
      registeredEmailErrorMessage: "",
      isOtpValid: true,
      otpErrorMessage: "",
      newPassword: "",
      confirmPassword: "",
      isNewPasswordValid: true,
      isConfirmPasswordValid: true,
      newPasswordErrorMessage: "",
      confirmPasswordErrorMessage: ""
    };
    // Customizable Area End
  }
  async componentDidMount() {
    super.componentDidMount();
    this.validationRulesRequest();
  }
  // Customizable Area End

  async receive(from, message) {
    // Customizable Area Start
    if (getName(MessageEnum.NavigationPayLoadMessage) === message.id) {
      const otpAuthTkn = message.getData(getName(MessageEnum.AuthTokenDataMessage));
      if (otpAuthTkn && otpAuthTkn.length > 0) {
        this.setState({
          token: otpAuthTkn
        });
        if (this.isChangePassword) {
          this.setState({
            accountStatus: "ChangePassword"
          });
        }
        this.otpToken = this.state.token;
        // runEngine.debugLog("otpAuthTkn", this.state.token);
      } else {
        const accountType = message.getData(getName(MessageEnum.NavigationForgotPasswordPageInfo));
        if (accountType) {
          this.startForgotPassword(accountType);
        }
      }
    } else if (getName(MessageEnum.RestAPIResponceMessage) === message.id && this.validationAPICallId && this.validationAPICallId === message.getData(getName(MessageEnum.RestAPIResponceDataMessage))) {
      var responseJson = message.getData(getName(MessageEnum.RestAPIResponceSuccessMessage));
      if (responseJson === undefined) {
        return;
      }
      if (responseJson && responseJson.data[0]) {
        const passRegex = RegExp(responseJson.data[0].password_validation_regexp);
        const emailRegex = RegExp(responseJson.data[0].email_validation_regexp);
        const passwordRulesFromValidation = responseJson.data[0].password_validation_rules;
        this.setState({
          //email schema
          emailSchema: {
            email: Yup.string().email(configJSON.pleaseEnterAValidEmail).required(configJSON.emailIsRequired).matches(emailRegex, configJSON.invalidEmailAddress)
          },
          //password schema
          passwordSchema: {
            password: Yup.string().required(configJSON.pleaseEnterAPassword).matches(passRegex, configJSON.invalidPassword),
            confirmPassword: Yup.string().required(configJSON.pleaseConfirmYourPassword).when("password", {
              is: val => val && val.length > 0 ? true : false,
              then: Yup.string().oneOf([Yup.ref("password")], configJSON.passwordsMustMatch)
            })
          },
          passwordRules: passwordRulesFromValidation
        });
      }
    } else if (getName(MessageEnum.RestAPIResponceMessage) === message.id && this.requestEmailOtpCallId !== null && this.requestEmailOtpCallId === message.getData(getName(MessageEnum.RestAPIResponceDataMessage))) {
      // console.log("entered email!!!!");
      var responseJson = message.getData(getName(MessageEnum.RestAPIResponceSuccessMessage));
      if (responseJson !== undefined && responseJson.meta && responseJson.meta.token) {
        this.otpToken = responseJson.meta.token;
        this.setState({
          token: this.otpToken
        });

        //navigate to OTP page
        const msg = new Message(getName(MessageEnum.NavigationMobilePhoneOTPMessage));
        msg.addData(getName(MessageEnum.AuthTokenDataMessage), this.state.token);
        msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
        msg.addData(getName(MessageEnum.AuthTokenEmailMessage), this.state.emailValue);
        msg.addData(getName(MessageEnum.EnterOTPAsForgotPasswordMessage), true);
        this.send(msg);
      }
      //error handling
      else if (responseJson && responseJson.errors) {
        this.parseApiErrorResponse(responseJson);
      } else {
        var errorReponse = message.getData(getName(MessageEnum.RestAPIResponceErrorMessage));
        this.parseApiCatchErrorResponse(errorReponse);
      }
    } else if (getName(MessageEnum.RestAPIResponceMessage) === message.id && this.requestPhoneOtpCallId !== null && this.requestPhoneOtpCallId === message.getData(getName(MessageEnum.RestAPIResponceDataMessage))) {
      // console.log("entered phone!!!!");
      var responseJson = message.getData(getName(MessageEnum.RestAPIResponceSuccessMessage));
      if (responseJson !== undefined && responseJson.meta && responseJson.meta.token) {
        this.otpToken = responseJson.meta.token;
        this.setState({
          token: this.otpToken
        });
        const msg = new Message(getName(MessageEnum.NavigationMobilePhoneOTPMessage));
        msg.addData(getName(MessageEnum.AuthTokenDataMessage), this.state.token);
        msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
        msg.addData(getName(MessageEnum.AuthTokenPhoneNumberMessage), this.state.phoneValue);
        msg.addData(getName(MessageEnum.EnterOTPAsForgotPasswordMessage), true);
        this.send(msg);
      }
      //error handling
      else if (responseJson && responseJson.errors) {
        this.parseApiErrorResponse(responseJson);
      } else {
        var errorReponse = message.getData(getName(MessageEnum.RestAPIResponceErrorMessage));
        this.parseApiCatchErrorResponse(errorReponse);
      }
    } else if (getName(MessageEnum.RestAPIResponceMessage) === message.id && this.requestGoToConfirmationCallId !== null && this.requestGoToConfirmationCallId === message.getData(getName(MessageEnum.RestAPIResponceDataMessage))) {
      // console.log("entered 3");
      var responseJson = message.getData(getName(MessageEnum.RestAPIResponceSuccessMessage));
      if (responseJson !== undefined && responseJson.data) {
        this.setState({
          accountStatus: "Confirmation"
        });
      } else if (responseJson !== undefined && responseJson.errors) {
        this.parseApiErrorResponse(responseJson);
      } else {
        var errorReponse = message.getData(getName(MessageEnum.RestAPIResponceErrorMessage));
        this.parseApiCatchErrorResponse(errorReponse);
      }
    } else if (getName(MessageEnum.CountryCodeMessage) === message.id) {
      var selectedCode = message.getData(getName(MessageEnum.CountyCodeDataMessage));
      if (selectedCode !== undefined) {
        this.setState({
          countryCodeSelected: selectedCode.indexOf("+") > 0 ? selectedCode.split("+")[1] : selectedCode
        });
      }
    }
    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(getName(MessageEnum.RestAPIResponceDataMessage));
      var responseJson = message.getData(getName(MessageEnum.RestAPIResponceSuccessMessage));
      var errorReponse = message.getData(getName(MessageEnum.RestAPIResponceErrorMessage));
      if (apiRequestCallId === this.sendOtpEmailApiCallId) {
        if (responseJson) {
          if (responseJson.errors || responseJson.error) {
            if (responseJson.errors) {
              if (responseJson.errors.length !== 0) {
                this.parseApiCatchErrorResponse(responseJson.errors[0].otp);
              }
            } else {
              this.parseApiCatchErrorResponse(responseJson.error);
            }
          } else {
            if (responseJson.meta) {
              localStorage.setItem("token", responseJson.meta.token);
            }
            if (responseJson.data) {
              localStorage.setItem("userId", responseJson.data.id);
              this.props.navigation.navigate("ForgotPasswordOTP");
            }
          }
        }
      } else if (apiRequestCallId === this.validateOtpApiCallId) {
        if (responseJson.errors) {
          if (responseJson.errors.length !== 0) {
            if (responseJson.errors[0].pin) {
              this.setState({
                isOtpValid: false,
                otpErrorMessage: responseJson.errors[0].pin,
                otp: ""
              });
              this.parseApiCatchErrorResponse(responseJson.errors[0].pin);
            } else if (responseJson.errors[0].otp) {
              this.setState({
                isOtpValid: false,
                otpErrorMessage: responseJson.errors[0].otp,
                otp: ""
              });
              this.parseApiCatchErrorResponse(responseJson.errors[0].otp);
            }
          }
        } else {
          if (responseJson.messages) {
            if (responseJson.messages.length !== 0) {
              if (responseJson.messages[0].otp) {
                if (responseJson.messages[0].otp == "OTP validation success") {
                  this.props.navigation.navigate("NewPassword");
                }
              }
            }
          }
        }
      } else if (apiRequestCallId === this.resetPasswordApiCallId) {
        if (responseJson.data) {
          if (Object.keys(responseJson.data).length !== 0) {
            this.props.navigation.navigate("ForgotPasswordSuccess");
          }
        } else if (responseJson.errors) {
          console.log(responseJson);
          if (responseJson.errors.length !== 0) {
            if (responseJson.errors[0].token) {
              this.parseApiCatchErrorResponse(responseJson.errors[0].token);
            } else if (responseJson.errors[0].password) {
              this.parseApiCatchErrorResponse(responseJson.errors[0].password);
            }
          }
        }
      }
    }

    // Customizable Area End
  }

  // Customizable Area Start

  startForgotPassword(accountType) {
    this.setState({
      accountStatus: accountType === "sms" ? "EnterPhone" : "EnterEmail"
    });
  }
  goToOtpAfterEmailValidation(values) {
    //change status to OTP
    const header = {
      "Content-Type": configJSON.forgotPasswordAPiContentType
    };
    const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
    //GO TO REQUEST STATE
    this.requestEmailOtpCallId = requestMessage.messageId;
    requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), configJSON.passwordRecoveryStartOtpAPiEndPoint);
    requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
    this.setState({
      emailValue: values.email ? values.email : ""
    });
    const data = {
      type: values.accountType ? values.accountType : "email_account",
      attributes: {
        email: values.email ? values.email : ""
      }
    };
    const httpBody = {
      data: data
    };
    requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), configJSON.httpPostMethod);
    requestMessage.addData(getName(MessageEnum.RestAPIRequestBodyMessage), JSON.stringify(httpBody));
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }
  goToOtpAfterPhoneValidation(values) {
    // console.log("entered phone validation code");
    if (!this.state.countryCodeSelected || this.state.countryCodeSelected.length === 0) {
      this.showAlert(configJSON.goToOtpAfterPhoneValidationErrorTitle, configJSON.goToOtpAfterPhoneValidationErrorBody);
      return;
    }
    //change status to OTP
    const header = {
      "Content-Type": configJSON.forgotPasswordAPiContentType
    };
    const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
    //GO TO REQUEST STATE
    this.requestPhoneOtpCallId = requestMessage.messageId;
    requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), configJSON.passwordRecoveryStartOtpAPiEndPoint);
    requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
    this.setState({
      phoneValue: this.state.countryCodeSelected && values.phone ? this.state.countryCodeSelected + values.phone : ""
    });
    const data = {
      type: "sms_account",
      attributes: {
        full_phone_number: this.state.phoneValue
      }
    };
    const httpBody = {
      data: data
    };
    requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), configJSON.httpPostMethod);
    requestMessage.addData(getName(MessageEnum.RestAPIRequestBodyMessage), JSON.stringify(httpBody));
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }
  goToChangePasswordAfterOtp(values) {
    //change status to change password
    //change status to OTP
    const header = {
      "Content-Type": configJSON.forgotPasswordAPiContentType
    };
    const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
    //GO TO REQUEST STATE
    this.requestChangePasswordCallId = requestMessage.messageId;
    requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), configJSON.passwordRecoveryConfirmOtpAPiEndPoint);
    requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
    const data = {
      token: this.otpToken ? this.otpToken : "",
      otp_code: values.otpCode ? values.otpCode : ""
    };
    const httpBody = {
      data: data
    };
    requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), configJSON.httpPostMethod);
    requestMessage.addData(getName(MessageEnum.RestAPIRequestBodyMessage), JSON.stringify(httpBody));
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }
  goToConfirmationAfterPasswordChange(values) {
    const header = {
      "Content-Type": configJSON.forgotPasswordAPiContentType
    };
    const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
    //GO TO REQUEST STATE
    this.requestGoToConfirmationCallId = requestMessage.messageId;
    requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), configJSON.passwordRecoveryChangePasswordAPiEndPoint);
    requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
    const data = {
      token: this.otpToken ? this.otpToken : "",
      new_password: values.password
    };
    const httpBody = {
      data: data
    };
    requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), configJSON.httpPostMethod);
    requestMessage.addData(getName(MessageEnum.RestAPIRequestBodyMessage), JSON.stringify(httpBody));
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }
  goToHome() {
    const msg = new Message(getName(MessageEnum.NavigationHomeScreenMessage));
    msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(msg);
  }
  goToLogin() {
    const msg = new Message(getName(MessageEnum.NavigationEmailLogInMessage));
    msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(msg);
  }

  // Customizable Area End
}